import styled from '@emotion/styled';

export const StyledSpinnerWrapper = styled.div`
  width: 100%;
  height: 40rem;
  overflow-y: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 2rem;
`;
